export const DocBaySupportLink =
  process.env.REACT_APP_DOCBAY_SUPPORT_LINK || '';
